import React from "react";
import Icons from "../Icons";
import Paragraph from "../../ui/Paragraph";
import FlipCard from "../FlipCard";

const ImageCards = ({ detail }) => {
  return (
    <div className="w-full">
      <div className="flex max-md:flex-col h-full w-full gap-y-4 sm:gap-y-6 ">
        <div className="md:pr-3 w-full xl:w-6/12 h-full">
          <div className="flex flex-col h-full gap-y-6">
            {detail.description ? (
              <div className="bg-custom-blue-v2 w-full p-5 rounded-lg">
                <div className="flex gap-x-4 md:gap-x-[18px] max-md:justify-center">
                  <Icons icon="blue-badge-strap" />
                  <div className="flex flex-col justify-between ">
                    <h2 className="font-bold text-[37px] uppercase !leading-100 text-white">
                      12K+
                    </h2>
                    <p className="font-bold !leading-150 text-sm text-white">
                      Happy Clients
                    </p>
                  </div>
                </div>
                {detail.description.map((detail, index) => (
                  <Paragraph
                    key={index}
                    variant="white"
                    className="pt-3.5 sm:pt-4 md:pt-5 md:max-w-[222px] max-md:text-center">
                    {detail}
                  </Paragraph>
                ))}
              </div>
            ) : (
              <div className="flex grow w-full rounded-lg overflow-clip h-[200px]">
                <div className="relative w-full">
                  <div className="w-full absolute top-0 left-0 h-full">
                    <FlipCard imageUrl={detail.img}></FlipCard>
                  </div>
                  <img
                    className="object-cover w-full object-center pointer-events-none opacity-0"
                    src={detail.img}
                    alt="card one"
                  />
                </div>{" "}
              </div>
            )}

            <div className="flex grow w-full rounded-lg overflow-clip h-[200px]">
              <div className="relative w-full">
                <div className="w-full absolute top-0 left-0 h-full">
                  <FlipCard imageUrl={detail.img1}></FlipCard>
                </div>
                <img
                  className="object-cover w-full object-center pointer-events-none opacity-0"
                  src={detail.img1}
                  alt="card one"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex grow md:pl-3 w-full xl:w-6/12  sm:max-w-[300px]">
          <div className="flex grow h-full w-full rounded-lg overflow-clip">
            <div className="relative w-full">
              <div className="w-full absolute top-0 left-0 h-full">
                <FlipCard imageUrl={detail.img2}></FlipCard>
              </div>
              <img
                className="object-cover w-full object-center h-full opacity-0 pointer-events-none"
                src={detail.img2}
                alt="card one"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCards;
